export default __webpack_public_path__ + "static/media/network.c315deac.jpg";